import React from "react";

/**
 * TechnicalId Component - Displays the technical scale identifier (s{x}m{x})
 * 
 * @param {number} superscaleIndex - The superscale index
 * @param {number} mode - The mode number
 */
const TechnicalId = ({ superscaleIndex, mode }) => {
  return (
    <div className="scale-technical-id">
      s{superscaleIndex}m{mode}
    </div>
  );
};

export default TechnicalId;